
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageFiller } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class Filler extends Vue {
  @Prop()
  modelValue!: IFlexMessageFiller

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageFiller) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: 'フィラー',
        value: 'filler',
      },
    ]
  }
}
